
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46.09 37.898c-.181-.333-.712-.556-1.493-.986-.781-.43-4.618-2.487-5.343-2.779-.726-.291-1.242-.444-1.8.334s-2.149 2.5-2.637 3.014c-.488.514-.949.556-1.73.14-.781-.431-3.307-1.362-6.25-4.168-2.289-2.195-3.782-4.849-4.228-5.655-.433-.805 0-1.222.405-1.597.376-.347.837-.903 1.241-1.348.419-.444.558-.778.851-1.292.28-.514.168-.986-.014-1.389-.181-.403-1.632-4.362-2.232-5.974-.6-1.611-1.27-1.375-1.744-1.389-.46-.014-.99-.097-1.52-.125-.53-.014-1.396.153-2.163.917-.754.764-2.888 2.612-3.028 6.502-.153 3.903 2.567 7.765 2.944 8.321.377.542 5.176 9.002 13.143 12.475 7.966 3.474 8.008 2.418 9.473 2.334 1.465-.083 4.786-1.736 5.511-3.57.754-1.834.81-3.417.614-3.765z"}}),_c('path',{attrs:{"d":"M1.388 59.737c-.377 0-.753-.153-1.018-.445a1.42 1.42 0 01-.293-1.417l4.422-12.267a29.657 29.657 0 01-4.492-15.74C.007 13.392 13.457 0 30.003 0 46.55 0 60 13.392 60 29.868c0 16.477-13.45 29.869-29.997 29.869a30.124 30.124 0 01-14.65-3.793L1.766 59.695a1.738 1.738 0 01-.377.042zm14.147-6.682c.251 0 .489.07.712.194 4.143 2.431 8.901 3.71 13.742 3.71 14.999 0 27.207-12.156 27.207-27.09 0-14.935-12.208-27.09-27.207-27.09-14.998 0-27.206 12.155-27.206 27.09 0 5.279 1.52 10.405 4.423 14.809.237.36.293.82.14 1.222l-3.74 10.392L15.16 53.11a1.18 1.18 0 01.376-.055z"}})])
          )
        }
      }
    